import { tryDoFetchWithRedirect } from "../../../lib/tryDoFetchWithRedirect";

export const doLogin = async (username, password) => {
  const body = btoa(username + ":" + password);
  await tryDoFetchWithRedirect("/research/japi/user/authenticate", body, "POST");
};
export const getSidFromResponse = (json) => {
  try {
    return json.statusText.split("sid=")[1];
  } catch (err) {
    console.error("Could not extract sid token from json response: ", json);
    return "";
  }
};
